import {
  LOTTERY_MY_TICKETS_TABS,
  GET_LOTTERY_MY_TICKET_LIST_REQUEST,
  GET_LOTTERY_MY_TICKET_LIST_SUCCESS,
  GET_LOTTERY_MY_TICKET_LIST_FAILURE,
  GET_LOTTERY_MY_TICKET_LIST_RESET,
  GET_LOTTERY_MY_TICKET_DETAIL_REQUEST,
  GET_LOTTERY_MY_TICKET_DETAIL_SUCCESS,
  GET_LOTTERY_MY_TICKET_DETAIL_FAILURE,
  GET_LOTTERY_MY_TICKET_DETAIL_RESET
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

const lotteryTabEnums = [
  { tabCode: 'WON', tabName: 'Kazanan', url: 'kazanan' },
  { tabCode: 'LOST', tabName: 'Kaybeden', url: 'kaybeden' }
];

const lotteryTabCodes = {
  'devam-eden': 'ASSIGNED',
  kazanan: 'WON',
  kaybeden: 'LOST'
};

export const getLotteryMyTicketsTabs = () => async (dispatch, getState) => {
  const myTicketsTabs = {
    status: { code: 200, message: 'Success' },
    tabs: lotteryTabEnums
  };

  dispatch({
    type: LOTTERY_MY_TICKETS_TABS,
    payload: myTicketsTabs
  });
};

export const getLotteryMyTicketList = (tabName, isSuper = false) => async (dispatch, getState) => {
  let pagination = getState().lottery.lotteryMyTickets.ticketList.pagination;
  let { start, end, pageSize } = pagination;

  try {
    dispatch({
      type: GET_LOTTERY_MY_TICKET_LIST_REQUEST
    });

    const activeTab = lotteryTabEnums.find(tab => tab.url === tabName && tab.tabCode);
    const apiBase = isSuper ? 'super-lottery' : 'lottery';

    if (activeTab) {
      const res = await axios({
        method: 'get',
        url: `${API_GATEWAY}/mobile/${apiBase}/ticket/assigned`,
        params: {
          start,
          end,
          status: activeTab.tabCode
        },
      });

      if (res.data.status.code !== 200 || (res.data.tickets && res.data.tickets.length < 1)) {
        throw res;
      }

      pagination = {
        ...pagination,
        start: start + pageSize,
        end: end + pageSize,
        hasMore: true
      };
  
      dispatch({
        type: GET_LOTTERY_MY_TICKET_LIST_SUCCESS,
        payload: res.data,
        pagination: pagination
      });
    }

  } catch (e) {
    dispatch({
      type: GET_LOTTERY_MY_TICKET_LIST_FAILURE,
      payload: e && e.data || errorMessage
    });
  }
};

export const resetLotteryMyTicketList = () => ({
  type: GET_LOTTERY_MY_TICKET_LIST_RESET
});

export const getLotteryMySharedTicketList = tabName => async (dispatch, getState) => {
  let pagination = getState().lottery.lotteryMyTickets.ticketList.pagination;
  try {
    dispatch({
      type: GET_LOTTERY_MY_TICKET_LIST_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/lottery/common-tickets/history`,
      method: 'get',
      params: {
        status: lotteryTabCodes[tabName],
        pageNumber: pagination.pageIndex,
        pageSize: pagination.pageSize
      }
    });

    pagination = {
      ...pagination,
      pageIndex: pagination.pageIndex + 1,
      hasMore: true
    };

    dispatch({
      type: GET_LOTTERY_MY_TICKET_LIST_SUCCESS,
      payload: res.data,
      pagination: pagination
    });

  } catch (e) {

    dispatch({
      type: GET_LOTTERY_MY_TICKET_LIST_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getLotteryMyTicketDetail = (tabName, ticketType, packetId) => async dispatch => {
  try {
    dispatch({
      type: GET_LOTTERY_MY_TICKET_DETAIL_REQUEST
    });

    const res = await axios({
      url: `${API_GATEWAY}/lottery/common-tickets/history/${packetId}`,
      method: 'get'
    });

    dispatch({
      type: GET_LOTTERY_MY_TICKET_DETAIL_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_LOTTERY_MY_TICKET_DETAIL_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const resetLotteryMyTicketDetail = () => ({
  type: GET_LOTTERY_MY_TICKET_DETAIL_RESET
});
